import { WizardStep } from '../../../private/request/store/wizard-request.store';
import { ConfirmationStepComponent } from '../components/confirmation-step/confirmation-step.component';
import { FinishStepComponent } from '../components/finish-step/finish-step.component';
import { IdentificationStepComponent } from '../components/identification-step/identification-step.component';
import { OutdatedQuoteComponent } from '../components/outdated-quote/outdated-quote.component';
import { PaymentStepComponent } from '../components/payment-step/payment-step.component';

export const stepsConfig: WizardStep[] = [
  {
    id: 'identification',
    label: 'identification',
    isActive: false,
    isCompleted: false,
    order: 1,
    hasTour: false,
    componentType: IdentificationStepComponent,
  },
  {
    id: 'information',
    label: 'information',
    isActive: false,
    isCompleted: false,
    title: 'information',
    order: 2,
    hasTour: true,
    subtitle: 'inTheNextStepYouWillHave',
    componentType: PaymentStepComponent,
  },
  {
    id: 'payment',
    label: 'payment_flow.payment',
    isActive: false,
    isCompleted: false,
    noButtons: true,
    order: 3,
    hasTour: true,
    title: 'payment_flow.payment',
    nextLabel: 'iHaveSent',
    componentType: ConfirmationStepComponent,
  },
  {
    id: 'success',
    label: 'success',
    isActive: false,
    isCompleted: true,
    lastStep: true,
    noButtons: true,
    order: 4,
    componentType: FinishStepComponent,
  },
  {
    id: 'outdated',
    isActive: false,
    isCompleted: true,
    noButtons: true,
    order: 5,
    componentType: OutdatedQuoteComponent,
  },
];
